import styled, { css } from "styled-components";
import { borderRadius, boxShadow, breakpoint, color, elevation, hoverColor, onHover, units } from "@m/alchemy-theme";
import { motion } from "framer-motion";
import { PortalRoot } from "../portal-root/PortalRoot";
export const DIALOG_TRANSITION_DURATION = 100;
export const DIALOG_TRANSITION_DELAY = 150;
export const sizes = {
    small: "400px",
    medium: "600px",
    large: "800px",
    extraLarge: "1000px",
    fullpage: "90%"
};
export const slideRightMotionVariants = {
    hidden: {
        opacity: 0,
        x: "-100%"
    },
    visible: {
        opacity: 1,
        x: "0%",
        transition: {
            duration: 0.15,
            ease: "easeInOut",
            delay: 0.05
        }
    },
    exit: {
        opacity: 0,
        x: "-100%",
        transition: {
            duration: 0.15,
            ease: "easeInOut"
        }
    }
};
export const slideLeftMotionVariants = {
    hidden: {
        opacity: 0,
        x: "100%"
    },
    visible: {
        opacity: 1,
        x: "0%",
        transition: {
            duration: 0.15,
            ease: "easeInOut",
            delay: 0.05
        }
    },
    exit: {
        opacity: 0,
        x: "100%",
        transition: {
            duration: 0.15,
            ease: "easeInOut"
        }
    }
};
export const contentMotionVariants = {
    hidden: {
        opacity: 0,
        scale: 0.25
    },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.15,
            ease: "easeInOut",
            delay: 0.05
        }
    },
    exit: {
        opacity: 0,
        scale: 0.25,
        transition: {
            duration: 0.15,
            ease: "easeInOut"
        }
    }
};
export const backdropMotionVariants = {
    initial: { opacity: 0 },
    animate: {
        opacity: 1,
        transition: { duration: 0.2, ease: "easeInOut" }
    },
    exit: { opacity: 0, transition: { duration: 0.2, ease: "easeInOut", delay: 0.05 } }
};
export const DialogRoot = styled(motion(PortalRoot)) `
  align-items: center;
  display: flex;
  bottom: 0;
  justify-content: ${({ attachedTo }) => (attachedTo ? (attachedTo === "left" ? "flex-start" : "flex-end") : "center")};
  left: 0;
  max-height: 100vh;
  position: ${({ isConstrainedToPortalRoot }) => (isConstrainedToPortalRoot ? "absolute" : "fixed")};
  top: 0;
  width: 100%;
  z-index: ${elevation("modal")};
  background: ${({ scrimStyle }) => scrimStyle === "light"
    ? color("container", { opacity: 0.65 })
    : color("base", {
        palette: "interactiveNavigational",
        opacity: 0.65
    })};
`;
const DialogContents = styled.div `
  background-color: ${color("container")};
  color: ${color("typeBody")};
  border-radius: ${({ $attachedTo }) => ($attachedTo ? 0 : borderRadius("extraLarge"))};
  box-shadow: ${boxShadow("dialog")};
  display: flex;
  flex-direction: column;
  max-height: ${({ $contentHeight }) => ($contentHeight ? $contentHeight : "95%")};
  position: relative;
  width: ${({ $contentWidth = "auto" }) => $contentWidth};
  height: ${({ $contentHeight = "unset" }) => $contentHeight};
  z-index: 1;

  padding: ${({ $contentPadding = "16px" }) => $contentPadding};

  @media (min-width: ${breakpoint("medium")}px) {
    padding: ${({ $contentPadding = "24px" }) => $contentPadding};
  }
`;
export const MotionDialogContents = motion(DialogContents);
export const DialogCloseIcon = styled.div `
  transition: all 0.2s ease-in;
  z-index: 1;

  position: absolute;
  top: ${units(2)};
  right: ${units(1.5)};

  @media (min-width: ${breakpoint("medium")}px) {
    right: ${units(2.5)};
    top: ${units(3)};
  }

  svg {
    color: ${color("base")};
  }

  ${onHover(css `
    svg {
      color: ${hoverColor("base")};
    }
  `)}
`;
export const DialogIconWrapper = styled.div `
  width: 100%;
  margin: ${units(2)} 0 ${units(3)} 0;
  text-align: center;

  svg {
    width: ${units(8)};
    height: ${units(8)};
  }
`;
